import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DataRecentIcare } from "../../interface";
import { getRecentIcareData } from "src/api/bi";
import { resetStore } from "src/store/actions";

export const fetchRecentIcareData = createAsyncThunk(
  "dashboard/fetchRecentIcareData",
  ({ storeId }: { storeId: string }) => {
    return getRecentIcareData({ storeId });
  }
);

type RecentIcareInitialState = {
  status: string;
  recentIcareData: DataRecentIcare[];
  error: string;
};

const initialState: RecentIcareInitialState = {
  status: "idle",
  recentIcareData: [],
  error: ""
};

const recentIcareSlice = createSlice({
  name: "recentIcare",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchRecentIcareData.pending, (state) => {
        state.status = "pending";
      })
      .addCase(fetchRecentIcareData.fulfilled, (state, { payload }) => {
        state.status = "idle";
        if (payload?.root?.result?.length) {
          state.recentIcareData = payload?.root?.result;
        } else state.recentIcareData = null;
      })
      .addCase(fetchRecentIcareData.rejected, (state, action) => {
        state.status = "error";
      });
  }
});

export default recentIcareSlice.reducer;
